/** Env var name for the Monthly Payment Plan Google Chat space (TopUpCourseModal). */
export const MONTHLY_PAYMENT_PLAN_GOOGLE_CHAT_WEBHOOK_ENV_KEY =
  'REACT_APP_MONTHLY_PAYMENT_PLAN_GOOGLE_CHAT_WEBHOOK';

/**
 * Google Chat — Monthly Payment Plan requests (TopUpCourseModal).
 */
export const MONTHLY_PAYMENT_PLAN_GOOGLE_CHAT_SPACE_ID = 'AAQAKEA00QE';

export const MONTHLY_PAYMENT_PLAN_GOOGLE_CHAT_WEBHOOK_URL = `https://chat.googleapis.com/v1/spaces/${MONTHLY_PAYMENT_PLAN_GOOGLE_CHAT_SPACE_ID}/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=QadS8IRjTi4sK1m85COs3PGlsBjNpr2gPlAA-fI2-jc`;

/** Env var name for the separate "LP Subscription Pause" Google Chat space. */
export const LP_SUBSCRIPTION_PAUSE_GOOGLE_CHAT_WEBHOOK_ENV_KEY =
  'REACT_APP_LP_SUBSCRIPTION_PAUSE_GOOGLE_CHAT_WEBHOOK';

/** Google Chat — LP subscription cancellation requests. */
export const LP_SUBSCRIPTION_CANCEL_GOOGLE_CHAT_SPACE_ID = 'AAQAsKcohk0';

/** Env var name for the LP subscription cancellation Google Chat space. */
export const LP_SUBSCRIPTION_CANCEL_GOOGLE_CHAT_WEBHOOK_ENV_KEY =
  'REACT_APP_LP_SUBSCRIPTION_CANCEL_GOOGLE_CHAT_WEBHOOK';

/** Env var name for the "Course Plan Change" (upgrade/downgrade) Google Chat space. */
export const COURSE_PLAN_CHANGE_GOOGLE_CHAT_WEBHOOK_ENV_KEY =
  'REACT_APP_COURSE_PLAN_CHANGE_GOOGLE_CHAT_WEBHOOK';

/** Google Chat — Substitute tutor requests (substitute_tutor_booking experiment). */
export const SUBSTITUTE_TUTOR_BOOKING_GOOGLE_CHAT_SPACE_ID = 'AAQA6aKE9Xo';

/** Env var name for the Substitute Tutor Booking Google Chat space. */
export const SUBSTITUTE_TUTOR_BOOKING_GOOGLE_CHAT_WEBHOOK_ENV_KEY =
  'REACT_APP_SUBSTITUTE_TUTOR_BOOKING_GOOGLE_CHAT_WEBHOOK';
